import { render, staticRenderFns } from "./FormSummaryBar.vue?vue&type=template&id=45b263d0&scoped=true&"
import script from "./form-summary-bar.js?vue&type=script&lang=js&"
export * from "./form-summary-bar.js?vue&type=script&lang=js&"
import style0 from "./form-summary-bar.scss?vue&type=style&index=0&id=45b263d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b263d0",
  null
  
)

export default component.exports